import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateReasonsActions as PaginateActions } from 'store/ducks/reasons';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  ReasonsList,
  ReasonFilters,
  FindReasons,
} from 'components/Pages/ReverseLogistics/Configuration/Reasons';
import { ListingPageHeader, Paginator, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const ReasonsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('Reasons');

  const {
    data: reasons,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateReasons);

  const [query, setQuery] = useState<FindReasons>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.CategoryIcon />}
          title="Motivos - Logística Reversa"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/logistica-reversa/motivos/criar'} size="small">
              <S.PlusIcon /> Novo motivo
            </S.LinkButton>
          }
        />
        <ReasonFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <ReasonsList
          reasons={reasons}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
